var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ColorSwitcher",class:{ noColor: _vm.noColor },style:({ background: _vm.noColor ? 'none' : _vm.color }),on:{"click":_vm.cycleColor}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }